import api from "api";

export const getQuestionsFilters = () => {
  return api.get(`v1/qaIntegration/qaQuestionsFilters`);
};

export const getAllQuestions = (params) => {
  return api.get(`/v1/qaIntegration/getQaQuestions`, { params });
};

export const getAddNewQuestions = (payload) => {
  return api.post(`/v1/qaIntegration/addScoringFormQuestion`, payload);
};

export const getDeleteQuestions = (id ,data) => {
  return api.post(`/v1/qaIntegration/deleteScoringFormQuestion/${id}`,data);
};

export const getEditQuestions = (scoringFormQuestion ,id) => {
  const body = {
    scoringFormQuestion: scoringFormQuestion,
  };
  return api.put(`v1/qaIntegration/editScoringFormQuestion/${id}`, body);
};

export const getReorderQuestions = (payload) => {
  return api.post(`/v1/qaIntegration/reOrderScoringFormQuestions`, payload);
};
